document.addEventListener('DOMContentLoaded', function() {
    const stickyDiv = document.querySelector('.backpage-sticky');
    const content = document.getElementById('page-content');
    const ctas = document.querySelectorAll('.cdb-combo-component-fullWidth');

    if (!stickyDiv) return;

    const initialTopOffset = stickyDiv.offsetTop + 110;
    const topOffset = 30;
    const bottomBuffer = 120;
    let lastKnownScrollPosition = 0;
    let ticking = false;

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                stickyDiv.classList.add('is-hidden');
                return;
            }
            stickyDiv.classList.remove('is-hidden');
        });
    });

    ctas.forEach(cta => observer.observe(cta));

    function handleScroll() {
        const scrollTop = lastKnownScrollPosition;
        const contentBottom = content.offsetTop + content.offsetHeight;
        const stickyDivHeight = stickyDiv.offsetHeight;
    
        const maxScrollTop = contentBottom - stickyDivHeight - topOffset - bottomBuffer;
    

        if (scrollTop >= initialTopOffset && scrollTop < maxScrollTop) {
            stickyDiv.style.position = 'fixed';
            stickyDiv.style.top = `${topOffset}px`;
            stickyDiv.classList.add('is-sticky');
        } else if (scrollTop >= maxScrollTop) {
            stickyDiv.style.position = 'absolute';
            stickyDiv.style.top = `${maxScrollTop}px`;
        } else {
            stickyDiv.style.position = 'static';
            stickyDiv.classList.remove('is-sticky');
        }

        ticking = false;
    }

    // Scroll event with requestAnimationFrame
    window.addEventListener('scroll', function() {
        lastKnownScrollPosition = window.scrollY;

        if (!ticking) {
            ticking = true;
            requestAnimationFrame(handleScroll);
        }
    });
});
